/** Display-only labels for school onboarding steps; API values stay snake_case. */
const ONBOARDING_LABELS: Record<string, string> = {
  created: 'Created',
  admin_accepted: 'Admin Accepted',
  completed: 'Completed',
};

function snakeCaseToTitleCase(value: string): string {
  return value
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

/**
 * User-facing onboarding step label. Sorting/filtering should keep using raw `step` from the API.
 */
export function getOnboardingDisplayLabel(step?: string): string {
  if (!step) return '-';
  return ONBOARDING_LABELS[step] ?? snakeCaseToTitleCase(step);
}

/**
 * Label for the Dev Team school table onboarding badge (same rules as before: missing state → pending).
 * Sorting/filtering must keep using raw `school.onboarding_state` fields, not this string.
 */
export function getSchoolOnboardingListLabel(school: {
  onboarding_state?: { step?: string; completed?: boolean } | null;
}): string {
  if (school.onboarding_state == null) {
    return getOnboardingDisplayLabel('pending');
  }
  if (school.onboarding_state.completed) {
    return getOnboardingDisplayLabel('completed');
  }
  return getOnboardingDisplayLabel(school.onboarding_state.step ?? 'pending');
}
